$(function () {
    $('.jsShowMore').each(function (i, e) {
        let $el = $(e);
        let parent = $el.parent();
        let container = parent.find('.jsShowMoreContainer')
        if(container.length) {
            container.addClass('showMoreHidden');
            $el.one('click', function () {
                container.removeClass('showMoreHidden');
                $el.remove();
            });
        }
    });
});